import { inject, Injectable } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MembershipAssociateVm } from '../share/membership-associate-form';
import { MembershipUpdateForm } from '../../store/membership-update';
import { ValidatorService } from '../share/form/validators/validator.service';

@Injectable({ providedIn: 'root' })
export class MembershipUpdateVm {
  private fb = inject(FormBuilder);
  private membershipAssociateVm = inject(MembershipAssociateVm);
  private validator = inject(ValidatorService);

  formGroup = this.create();

  create() {
    return this.fb.group<MembershipUpdateForm>({
      firstName: new FormControl('', {
        nonNullable: true,
        validators: Validators.compose([Validators.required, this.validator.isValidName()]),
        updateOn: 'blur',
      }),
      lastName: new FormControl('', {
        nonNullable: true,
        validators: Validators.compose([Validators.required, this.validator.isValidName()]),
        updateOn: 'blur',
      }),
      accidentMedicalPlan: new FormControl(false, { nonNullable: true }),
      associates: this.membershipAssociateVm.create(),
      promoCode: new FormControl('', { nonNullable: true }),
      membershipType: new FormControl('', { nonNullable: true }),
      mvpCard: new FormControl(false, { nonNullable: true }),
    });
  }
}
